import Phaser from 'phaser';

export class PauseScene extends Phaser.Scene {
  constructor() { super('PauseScene'); }

  create() {
    const { width: w, height: h } = this.scale;
    this.add.rectangle(0, 0, w, h, 0x000000, 0.65).setOrigin(0, 0);

    this.add.text(w / 2, h * 0.32, 'PAUSED', {
      fontSize: '64px', color: '#ffd84a', fontStyle: 'bold', fontFamily: 'monospace'
    }).setOrigin(0.5).setShadow(2, 2, '#000', 0, true, true);

    this.makeButton(w / 2, h * 0.50, 220, 50, 'RESUME',     () => this.resume());
    this.makeButton(w / 2, h * 0.62, 220, 50, 'MAIN MENU',  () => this.toMenu());

    this.add.text(w / 2, h * 0.74, 'press Esc to resume', {
      fontSize: '12px', color: '#aab', fontStyle: 'italic'
    }).setOrigin(0.5);

    this.input.keyboard!.once('keydown-ESC', () => this.resume());
  }

  private resume() {
    this.scene.resume('GameScene');
    this.scene.stop();
  }

  private toMenu() {
    // Hard reset: reloading guarantees clean scene state.
    // Cheaper alternatives leave Phaser scenes in a half-restarted state where
    // PLAY pointerup re-grays the button but never re-runs GameScene.create().
    window.location.reload();
  }

  private makeButton(
    x: number, y: number, w: number, h: number, label: string, onClick: () => void
  ): Phaser.GameObjects.Container {
    const c = this.add.container(x, y);
    const bg = this.add.rectangle(0, 0, w, h, 0xffd84a, 1).setStrokeStyle(3, 0x000000, 1);
    const t = this.add.text(0, 0, label, {
      fontSize: '20px', color: '#1a1410', fontStyle: 'bold', fontFamily: 'monospace'
    }).setOrigin(0.5);
    c.add([bg, t]);
    c.setSize(w, h);
    c.setInteractive({ useHandCursor: true });
    c.on('pointerover', () => bg.setFillStyle(0xffe885));
    c.on('pointerout',  () => bg.setFillStyle(0xffd84a));
    c.on('pointerdown', () => bg.setFillStyle(0xc9a830));
    c.on('pointerup',   () => { bg.setFillStyle(0xffe885); onClick(); });
    return c;
  }
}
